import { render, staticRenderFns } from "./HelpPopupPage.vue?vue&type=template&id=3c8d7061&scoped=true&"
import script from "./HelpPopupPage.vue?vue&type=script&lang=js&"
export * from "./HelpPopupPage.vue?vue&type=script&lang=js&"
import style0 from "./HelpPopupPage.vue?vue&type=style&index=0&id=3c8d7061&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d7061",
  null
  
)

export default component.exports